<template>
  <div class="tw-p-4 legacy-lg:tw-p-6 tw-grid tw-gap-10">
    <SoundkitHeader class="tw-relative tw-z-10" :soundkit="soundkit" />
    <div class="tw-grid tw-gap-10 tw-items-start tw-relative tw-z-10" :class="{'md:tw-grid-cols-2': hasVideo}">
      <SoundkitVideo v-if="hasVideo" class="tw-bg-infinity-license-box-background-faded tw-shadow tw-rounded"
                     :class="soundkitVideoLayout"
                     :url="soundkit.youtubeEmbedLink" />
      <SoundkitAgreements v-if="soundkit.productPricing.length"
                          :class="agreementLayout"
                          :soundkit="soundkit" />
      <div :class="itemsLayout">
        <SoundkitPreviews v-if="soundkit.samples && soundkit.samples.length" :soundkit="soundkit" />
        <SoundkitFiles v-if="soundkit.itemsCount" :soundkit="soundkit" />
      </div>
    </div>
    <SoundkitBackground :src="soundkit.image(600)" />
  </div>
</template>
<script>
import SoundkitHeader from "./view/soundkit-header";
import SoundkitAgreements from "./view/soundkit-pricing";
import SoundkitFiles from "./view/soundkit-files";
import SoundKit from "../../models/soundkit";
import TheSoundkitPricingModal from "./TheSoundkitPricingModal";
import SoundkitBackground from "./view/soundkit-background";
import SoundkitVideo from "./view/soundkit-video";
import SoundkitPreviews from "./view/soundkit-previews";

export default {
  components: {
    SoundkitPreviews,
    SoundkitVideo,
    SoundkitBackground,
    TheSoundkitPricingModal,
    SoundkitFiles,
    SoundkitAgreements,
    SoundkitHeader
  },
  props: {
    soundkit: {
      type: SoundKit,
      required: true
    }
  },
  computed: {
    hasVideo() {
      return this.soundkit.youtubeEmbedLink;
    },
    moveItemsUp() {
      return this.soundkit.productPricing?.length > 2;
    },
    soundkitVideoLayout() {
      return [
        "md:tw-col-start-1",
        "md:tw-col-end-2",
        "md:tw-row-start-1"
      ];
    },
    agreementLayout() {
      return this.hasVideo && [
        "md:tw-row-start-1",
        this.moveItemsUp ? "md:tw-row-end-3" : "md:tw-row-end-2"
      ];
    },
    itemsLayout() {
      return this.hasVideo && !this.moveItemsUp && [
        "md:tw-col-start-1",
        "md:tw-col-end-3"
      ];
    }
  }
};
</script>
